import {NavLink } from 'react-router-dom';
import '../assets/css/profile.css'
import { MiniExit,MiniLocation,MiniLock,MiniOrders,MiniUser,MiniWallet } from '../../assets/icones/icones';
import {FormatNumberByhkh} from "../../clientconfigwebapp";
import Sticky from 'react-stickynode';
import React, {Fragment} from "react";

const  Menu_panel = (props) => {


    const data_item_menu = [
        {
            path: '/panel/profile',
            title: 'اطلاعات من',
            icon: <MiniUser color={'var(--c7)'} />
        },
        {
            path: '/panel/my-address',
            title: 'آدرس‌های من',
            icon: <MiniLocation color={'var(--c7)'} />
        },
        {
            path: '/panel/wallet',
            title: 'کیف پول',
            icon: <MiniWallet color={'var(--c7)'} />
        },
        {
            path: '/panel/my-orders',
            title: 'سفارشات من',
            icon: <MiniOrders color={'var(--c7)'} />
        },
        {
            path: '/panel/change-password',
            title: 'تغییر رمز عبور',
            icon: <MiniLock color={'var(--c7)'} />
        },
        {
            path: '/login',
            title: 'خروج از حساب کاربری',
            icon: <MiniExit color={'var(--c7)'} />
        },
    ]


    return (
        <>
            <Sticky top="#sidebarrightbk" bottomBoundary="#content">
            <div className="w-100 profile__container">
                <div className="flexColStartStart w-100 profile__container__header">
                    <span className={"profile__container_name_user"}>{String(props.first_name_profile) + " "   + String(props.last_name_profile)}</span>
                    <div className='flexRowBetCenter w-100'>
                        <span className={"profile__container_title-wallet"}>اعتبار کیف پول</span>
                        <span className={"profile__container_title-wallet"}>                          {  String(props.wallet_balance).length > 0 ?  (<Fragment>{FormatNumberByhkh(String(props.wallet_balance), ".", ",","t")}</Fragment> ) : (<Fragment>0 تومان</Fragment>)   }</span>
                    </div>
                </div>
                <div className="flexColStartStart w-100 profile__container__body">
                    <ul className='w-100'>
                        { data_item_menu.map((item, index) => {
                                return (
                                    <li key={index} className='w-100 menu-panel-sidebar-right'>
                                        <NavLink className={({isActive})=> isActive ? 'w-100 flexRowStartCenter pro-active' : 'w-100 flexRowStartCenter'} to={`${item.path}`}>
                                            {item.icon}
                                            <span>{item.title}</span>
                                        </NavLink>
                                    </li>
                                )
                            }
                        )}
                    </ul>
                </div>
            </div>
            </Sticky>
        </>
    )
}
export default Menu_panel;